import React from 'react';
import { Layout } from '../components/Layout';
import { ToolCard } from '../components/ToolCard';
import { Section } from '../components/ui/Section';
import { Container } from '../components/ui/Container';
import { SEO } from '../components/SEO';
import { TOOLS } from '../utils/constants';
import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ToolsLibrary() {
  const {
    t
  } = useLanguage();
  return <Layout data-id="element-5250">
      <SEO title="Cybersecurity Tools & Resources | CyberSecurityProtocol 101" description="Recommended cybersecurity tools and resources for password safety, MFA, backups, privacy protection, and organizational security readiness." keywords="cybersecurity tools, security tools, password manager, MFA tools, backup tools, privacy tools, breach check" url="https://cybersecurityprotocol.org/tools" data-id="element-5251" />

      <Section spacing="lg" data-id="element-5252">
        <Container size="lg" data-id="element-5253">
          <div className="mb-12" data-id="element-5254">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-4" data-id="element-5255">
              {t('tools.title')}
            </h1>
            <p className="text-slate-400 max-w-2xl text-lg mb-8" data-id="element-5256">
              {t('tools.subtitle')}
            </p>

            <div className="bg-yellow-500/10 border border-yellow-500/20 p-4 rounded-lg flex items-start max-w-3xl" data-id="element-5257">
              <AlertTriangle className="h-5 w-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5258" />
              <p className="text-sm text-yellow-200/80" data-id="element-5259">
                <strong data-id="element-5260">{t('tools.warning.title')}</strong>{' '}
                {t('tools.warning.desc')}
              </p>
            </div>
          </div>

          <div className="space-y-12" data-id="element-5261">
            {TOOLS.map((category, idx) => <div key={idx} data-id="element-5262">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 border-b border-slate-800 pb-2" data-id="element-5263">
                  {category.category}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5264">
                  {category.items.map((tool, tIdx) => <ToolCard key={tIdx} {...tool} data-id="element-5265" />)}
                </div>
              </div>)}
          </div>
        </Container>
      </Section>
    </Layout>;
}